export var EWindowBringToFront;
(function (EWindowBringToFront) {
    EWindowBringToFront[EWindowBringToFront["Invalid"] = 0] = "Invalid";
    EWindowBringToFront[EWindowBringToFront["AndForceOS"] = 1] = "AndForceOS";
    EWindowBringToFront[EWindowBringToFront["WithoutForcingOS"] = 2] = "WithoutForcingOS";
})(EWindowBringToFront || (EWindowBringToFront = {}));
